/**
 * Browser shim for Node `node:child_process` imports that leak into the bundle from
 * server-only `@smart-shikka/core` modules. This shim exists only so the SPA
 * build can tree-shake unused server code paths; any function actually called
 * at runtime is a developer error and fails loudly.
 */

function notAvailable(name: string): (...args: unknown[]) => never {
  return () => {
    throw new Error(`node:child_process.${name} is not available in the browser bundle`);
  };
}

export const ChildProcess = class {
  constructor() {
    throw new Error("node:child_process.ChildProcess is not available in the browser bundle");
  }
} as unknown as typeof import("node:child_process").ChildProcess;

export const exec = notAvailable("exec");
export const execFile = notAvailable("execFile");
export const execFileSync = notAvailable("execFileSync");
export const execSync = notAvailable("execSync");
export const fork = notAvailable("fork");
export const spawn = notAvailable("spawn");
